import { User } from '../../@types';
import { NavBarData } from '../../reducers/navBar/data';
import { IPA_NEGOTIATION_HOME_PATH, IPA_PRO_HOME_PATH, isIpaBasicPackage } from '../../utils/ipaAccess';
import { NavBarBadgeProps } from './NavBarBadge/NavBarBadge';

export const checkIsFree = (user?: User) => {
  return user?.servicoPanel?.pacotePainel.name === 'FREE';
};

export const checkIsDisabled = (key: NavOptionKeys, user?: User) => {
  return !user?.servicos?.some(({ name }) => name === key);
};

export const checkHasService = (key: NavOptionKeys, user?: User) => {
  return !!user?.servicosCliente?.some(({ name }) => name === key);
};

export const checkHasCustomizedPannels = (user?: User) => {
  return !!(user?.servicos?.some(item => item.name === 'BI') && (user?.servicoBi?.analises?.length || user?.servicoBi?.graficos?.length));
};

type NavOptionKeys = 'PAN' | 'COL' | 'IPA' | 'SDD' | 'BI' | 'IDT' | 'IRA';

export type NavOption = {
  key: NavOptionKeys;
  id: string;
  to: string;
  label: string;
  panel: string;
  skin: NavBarBadgeProps['skin'];
  isDisabled?: boolean;
  isFree?: boolean;
  hasService?: boolean;
};

export const navOptions = (user?: User): NavOption[] => {
  const isFree = checkIsFree(user);

  return [
    {
      key: 'PAN',
      id: isFree ? 'infopanel-free-navbar-link' : 'infopanel-navbar-link',
      to: isFree ? '/isa/painel-geral-free' : '/isa/painel-geral',
      label: 'InfoPanel',
      panel: 'ISA',
      skin: 'blue',
      isFree,
      isDisabled: checkIsDisabled('PAN', user),
      hasService: checkHasService('PAN', user),
    },
    {
      key: 'COL',
      id: isFree ? 'mpdv-navbar-link-free' : 'mpdv-navbar-link',
      to: '/isa/historico-preco',
      label: 'Monitoramento PDV',
      panel: 'ISA',
      skin: 'blue',
      isFree,
      isDisabled: checkIsDisabled('COL', user),
      hasService: checkHasService('COL', user),
    },
    {
      key: 'IPA',
      id: isFree ? 'pricing-software-navbar-link-free' : 'pricing-software-navbar-link',
      to: isIpaBasicPackage(user) ? IPA_NEGOTIATION_HOME_PATH : IPA_PRO_HOME_PATH,
      label: 'Software de precificação',
      panel: 'IPA',
      skin: 'purple',
      isFree,
      isDisabled: checkIsDisabled('IPA', user),
      hasService: checkHasService('IPA', user),
    },
    {
      key: 'SDD',
      id: isFree ? 'simulator-navbar-link-free' : 'simulator-navbar-link',
      to: '/ipa/calculadora-demanda',
      label: 'Simulador de demanda',
      panel: 'IPA',
      skin: 'purple',
      isFree,
      isDisabled: checkIsDisabled('SDD', user),
      hasService: checkHasService('SDD', user),
    },
    ...(user?.codigoCliente === 286852
      ? [
          {
            key: 'IDT',
            id: 'industry-navbar-link',
            to: '/ipa/plataforma-editar-tabela-base',
            label: 'Indústria',
            panel: 'IPA',
            skin: 'purple',
          } as NavOption,
        ]
      : []),
  ];
};

export const sortByEnabledFirst = (a: NavOption, b: NavOption) => {
  return Number(a.isDisabled) - Number(b.isDisabled);
};

export const findNavBarPayloadByKey = (key: NavOptionKeys, user?: User): NavBarData | null => {
  const option = navOptions(user).find(option => option.key === key);
  if (!option) return null;
  const { label, panel, isFree } = option;
  return { label, panel, isFree };
};
